<template>
  <v-container fluid>
      <BackButton class="mb-3" :target="{name: 'EntitiesPortal'}">{{ $t('entities.entity_portal') }}</BackButton>
    <v-row>
      <v-col
          v-for="item in statisticsCategories"
          :key="item.key"
          cols="12"
          sm="4">
        <v-card outlined>
          <v-card-title class="d-flex flex-column align-center text-center mt-4 text-h6 text-break text-wrap">
            <v-icon color="primary" x-large>{{ item.icon }}</v-icon>
            {{ $t(item.key) }}
          </v-card-title>
          <v-card-actions class="justify-center">
            <router-link :to="item.to">
              <v-btn color="primary" variant="text">{{$t('statistics.enter')}}</v-btn>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

import BackButton from "@/components/layout/BackButton";

export default {
  name: "StatisticsOverview",
  components:{
    BackButton
  },
  data() {
    return {
      statisticsCategories: [
        {
          key: 'statistics.occupation',
          target: "StatisticsOccupation",
          to: {name: "StatisticsOccupation"},
          icon: "event"
        }
      ]
    }
  }
}
</script>